__turbopack_context__.v({
  "grayscale": "n_Q97q_grayscale",
  "wrapper": "n_Q97q_wrapper",
});
